module.exports = __webpack_public_path__ + "img/study-from-books.da923e3e.svg";